<template>
  <div id="content">
    <h1>Painel de Ajuda em construção</h1>
  </div>
</template>

<script>

export default {
    name: "Support",
    components: {

    }
}
</script>

<style lang="scss" scoped>

</style>